import React, { useState } from 'react';
import { ChevronDown, ChevronUp, ArrowRight } from 'lucide-react';
import faqImage from '../../assets/business-meeting.jpg';

const FAQPage = () => {
  const [openFAQ, setOpenFAQ] = useState(null);

  const faqs = [
    {
          question: 'What is COREVEST?',
    answer: 'COREVEST is a comprehensive investment firm specializing in strategic investments across Blockchain-based Assets, Real Estate, Oil and Gas, and Stocks, offering clients tailored financial solutions.'
    },
    {
          question: 'How can I invest with COREVEST?',
    answer: 'Investing with COREVEST is simple. We offer direct investment programs for individual and organizational investors. Sign up on our platform to get started.'
    },
    {
              question: 'What are the benefits of investing with COREVEST?',
      answer: 'Investing with COREVEST provides access to a diversified portfolio managed by experts, ensuring risk mitigation, regular income through dividends, and potential capital growth.'
    },
    {
      question: 'Is COREVEST LIMITED suitable for individual investors?',
      answer: 'Yes, COREVEST LIMITED caters to individual investors seeking diversified investment opportunities and regular income without the hassle of managing properties or assets directly.'
    },
    {
      question: 'What types of assets does COREVEST LIMITED invest in?',
      answer: 'COREVEST LIMITED invests in a wide range of assets, including Blockchain-based Assets, Real Estate, Oil and Gas, and Stocks. Our diversified approach ensures optimal performance and growth.'
    },
    {
      question: 'How are COREVEST LIMITED investments taxed?',
      answer: 'Investments with COREVEST LIMITED are subject to standard taxation laws. We ensure that our investors receive their income after all applicable taxes have been duly processed.'
    },
    {
      question: 'What risks should I be aware of when investing with COREVEST LIMITED?',
      answer: 'While all investments carry risks, COREVEST LIMITED employs rigorous risk management strategies to protect your investments. We handle the complexities, ensuring minimized risk for our investors.'
    },
    {
      question: 'Can I reinvest the dividends I receive from COREVEST LIMITED?',
      answer: 'Yes, COREVEST LIMITED offers dividend reinvestment plans, allowing investors to compound their returns by reinvesting dividends back into their portfolios for greater growth potential.'
    }
  ];

  const toggleFAQ = (index) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative h-[60vh] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-navy-900/80 to-navy-800/60"></div>
        <div className="absolute inset-0">
          <img
            src={faqImage}
            alt="FAQ"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="relative z-10 text-center text-white">
          <h1 className="text-4xl md:text-6xl font-bold font-serif mb-4">FAQ</h1>
          <p className="text-xl md:text-2xl text-gray-200">
            Home / <span className="text-gold-400">FAQ</span>
          </p>
        </div>
      </section>

      {/* FAQ Content */}
      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold font-serif text-navy-900 mb-6">
              Frequently Asked Questions
            </h2>
            <p className="text-xl text-gray-600 leading-relaxed">
              Find answers to common questions about our investment services and how we can help you achieve your financial goals.
            </p>
          </div>

          {/* FAQ Items */}
          <div className="space-y-6">
            {faqs.map((faq, index) => (
              <div key={index} className="bg-white border border-gray-200 rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300">
                <button
                  className="w-full text-left p-6 focus:outline-none"
                  onClick={() => toggleFAQ(index)}
                >
                  <div className="flex justify-between items-center">
                    <h3 className="text-lg font-semibold text-navy-900 pr-4">
                      {faq.question}
                    </h3>
                    <div className="flex-shrink-0">
                      {openFAQ === index ? (
                        <ChevronUp className="h-5 w-5 text-gold-500" />
                      ) : (
                        <ChevronDown className="h-5 w-5 text-gray-400" />
                      )}
                    </div>
                  </div>
                </button>
                {openFAQ === index && (
                  <div className="px-6 pb-6">
                    <div className="border-t border-gray-100 pt-4">
                      <p className="text-gray-600 leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* CTA Section */}
          <div className="mt-20 bg-gradient-to-r from-gold-500 to-gold-600 rounded-2xl p-12 text-center text-white">
            <h3 className="text-3xl md:text-4xl font-bold font-serif mb-6">
              Be a part of our growing investment platform
            </h3>
            <p className="text-xl text-gold-100 mb-8 max-w-2xl mx-auto">
              Ready to start your investment journey? Join thousands of satisfied investors who trust COREVEST with their financial future.
            </p>
            <button className="inline-flex items-center justify-center px-8 py-4 bg-navy-900 hover:bg-navy-800 text-white font-bold rounded-full transition-colors duration-300">
              Join Us Today!
              <ArrowRight className="ml-2 h-5 w-5" />
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQPage; 